<p>login works!</p>
<!-- <table mat-table [dataSource]="dataSource" class="mat-table">

    <ng-container matColumnDef="sno">
        <th mat-header-cell *matHeaderCellDef> SNo. </th>
        <td mat-cell *matCellDef="let element"> {{element.sno}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef> Address </th>
        <td mat-cell *matCellDef="let element"> {{element.address}} </td>
    </ng-container>

    <thead>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    </thead>
    <tbody>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </tbody>
</table>

<br>
<br>
<button class="btn primary small">Primary Small</button>
<br>
<br>
<button class="btn primary medium">Primary Medium</button>
<br>
<br>
<button class="btn primary large">Primary Large</button>
<br>
<br>
<button class="btn secondary small">Secondary Small</button>
<br>
<br>
<button class="btn secondary medium">Secondary Medium</button>
<br>
<br>
<button class="btn secondary large">Secondary Large</button>
<br>
<br>
<button class="btn tertiary small">Tertiary Small</button>
<br>
<br>
<button class="btn tertiary medium">Tertiary Medium</button>
<br>
<br>
<button class="btn tertiary large">Tertiary Large</button>
<br>
<br>
<button class="btn primary medium full-width" disabled>Disabled Button</button> 

<mat-form-field>
    <textarea matInput rows="5" class="md" placeholder="Enter username"></textarea>
</mat-form-field>

<br>
<mat-label>Username_0</mat-label>
<mat-form-field>
    <img matPrefix src="../assets/icons/number-plate.svg" alt="icon">
    <input matInput class="xs" placeholder="Enter username">
    <img matSuffix src="../assets/icons/down.svg" alt="icon">
  </mat-form-field>
  <br>
<mat-label>Username lg: </mat-label>
<mat-form-field>
    <input matInput class="lg" placeholder="Enter username">
  </mat-form-field>
  <br>
  <mat-label>Email md: </mat-label>
  <mat-form-field>
    <img matPrefix src="/assets/icons/mail.svg" alt="icon">
    <input matInput class="md" [formControl]="emailFormControl" placeholder="Ex. pat@example.com">
    <mat-error>
        Please enter a valid email address
    </mat-error>
  </mat-form-field>
  <br>
  <mat-label>Favorite food sm: </mat-label>
  <mat-form-field>
    <input matInput class="sm" [(ngModel)]="food" placeholder="Ex. Pizza">
  </mat-form-field>
  <br>
  <mat-label>Name md: </mat-label>
  <mat-form-field>
    <input matInput class="md" required placeholder="Enter name">
  </mat-form-field>
  <br>
  <mat-label>Disabled field lg: </mat-label>
  <mat-form-field>
    <input matInput class="lg" disabled value="Disabled value">
  </mat-form-field>
<br>

-->